module.exports = __webpack_public_path__ + "fonts/PPRightGrotesk-CompactMedium.be7572e.woff2";